import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
// import Header from './components/Header';
// import Footer from './components/Footer';
import LandingPageNew from './pages/LandingPageNew';
// import NewLandingPage from './pages/NewLandingPage';
import DownloadPage from './pages/DownloadPage';
// import Dashboard from './pages/Dashboard';
// import Dataroom from './pages/PE/Dataroom';
// import ZoomMeeting from './pages/PE/ZoomMeeting';
// import Diligence from './pages/PE/Diligence';
// import ReLandingPage from './pages/RE/RELandingPage';
// import PropertyAnalysis from './pages/RE/PropertyAnalysis';
// import Scouting from './pages/RE/Scouting';
// import DashboardDemo from './pages/RE/DashboardDemo';
// import FinishedPayment from './pages/FinishedPayment';
import Support from './pages/Support';
import LegalDocPage from './pages/LegalDocPage';
import Enterprise from './pages/Enterprise';
// import { ExpiredAccountModal } from './components/ui/expiredAccountModal';
import './index.css';


function AppContent() {
  const location = useLocation();
  // const navigate = useNavigate();
  // const { logout } = useAuth();
  // const isZoomPage = location.pathname === '/zoom';
  const isNewLandingPage = location.pathname === '/excel';
  const isDownloadPage = location.pathname === '/download';
  const isSupportPage = location.pathname === '/support';
  const isEnterprisePage = location.pathname === '/enterprise';
  const isLegalPage = ['/privacy-policy', '/terms-of-service', '/eula'].includes(location.pathname);
  // const [showExpiredModal, setShowExpiredModal] = useState(false);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);

    // Google Analytics Page Tracking
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-G-J72H1M3F98', {
        page_path: location.pathname + location.search
      });
    }
  }, [location.pathname, location.search]);

  // Removed account expired logic - no longer needed without authentication

  return (
    <div className="App h-full flex flex-col bg-black">
      {/* Header removed - not used on Excel landing pages */}
      <main className={`flex-1 overflow-auto ${isNewLandingPage || isDownloadPage || isLegalPage || isSupportPage || isEnterprisePage ? '' : 'bg-black'}`}>
        <Routes>
          {/* No route for / - will be handled by main domain project */}
          <Route path="/excel" element={<LandingPageNew />} />
          {/* <Route path="/new" element={<NewLandingPage />} /> */}
          <Route path="/download" element={<DownloadPage />} />
          <Route path="/support" element={<Support />} />
          <Route path="/enterprise" element={<Enterprise />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          {/* <Route path="/subscription-success" element={<FinishedPayment />} /> */}
          {/* <Route path="/subscription-cancel" element={<FinishedPayment />} /> */}
          <Route path="/privacy-policy" element={<LegalDocPage documentName="privacy_policy.md" />} />
          <Route path="/terms-of-service" element={<LegalDocPage documentName="terms_of_service.md" />} />
          <Route path="/eula" element={<LegalDocPage documentName="eula.md" />} />
        </Routes>
      </main>
      {/* Footer removed - not used on Excel landing pages */}
      {/* ExpiredAccountModal removed - no longer needed without authentication */}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

